import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

/**
 * Testimonials — 3 quotes (clients or media mentions).
 * Props: { heading, items: [{quote, author, role, source?}], isRTL }
 */
const Testimonials = ({ heading, items = [], isRTL = false }) => (
  <section className="bg-white py-16 lg:py-20 border-y border-flame-100" data-testid="testimonials">
    <div className="max-w-[1240px] mx-auto px-6">
      <h2 className={`varo-display text-3xl lg:text-4xl mb-12 ${isRTL ? 'text-right' : 'text-center'}`}>{heading}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
        {items.map((t, i) => (
          <motion.figure key={i} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }} className={`bg-[#FAF7F2] rounded-3xl border border-flame-100 p-6 lg:p-7 relative ${isRTL ? 'text-right' : ''}`} data-testid={`testimonial-${i}`}>
            <Quote className={`w-9 h-9 text-flame-300 mb-4 ${isRTL ? 'scale-x-[-1] ml-auto' : ''}`} strokeWidth={1.5} />
            <blockquote className="text-ink-800 text-base leading-[1.75] mb-5 italic">"{t.quote}"</blockquote>
            <figcaption className={`flex items-center gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-flame-400 to-flame-600 flex items-center justify-center text-white varo-display text-sm">
                {(t.author || '?').charAt(0)}
              </div>
              <div>
                <div className="font-bold text-ink-900 text-sm">{t.author}</div>
                {(t.role || t.source) && <div className="text-ink-500 text-xs">{t.role}{t.role && t.source ? ' · ' : ''}{t.source}</div>}
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
